import React from 'react';
import PropTypes from 'prop-types';
import arrowLeft from '../../images/icon-double-arrow-left.svg';
import arrowRight from '../../images/icon-double-arrow-right.svg';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pageNumbers = [];

  // Calculate the main range of page numbers to display
  let startPage = Math.max(1, currentPage - 2);
  let endPage = Math.min(totalPages, currentPage + 2);

  // Adjust if we're near the beginning or end
  if (currentPage <= 3) {
    endPage = Math.min(5, totalPages);
  } else if (currentPage >= totalPages - 2) {
    startPage = Math.max(totalPages - 4, 1);
  }

  // Collect the main range of pages to display
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="pagination-wrap">
      <ul>
        {/* Previous Button */}
        {currentPage > 1 && (
          <li>
            <a onClick={() => onPageChange(currentPage - 1)}>
              <img src={arrowLeft} alt="Previous" />
            </a>
          </li>
        )}

        {/* First Page Button with Ellipsis */}
        {startPage > 1 && (
          <>
            <li>
              <a onClick={() => onPageChange(1)}>1</a>
            </li>
            <li key="start-ellipsis">...</li>
          </>
        )}

        {/* Page Number Buttons */}
        {pageNumbers.map((page) => (
          <li key={page} className={`${currentPage === page ? 'active' : ''}`}>
            <a onClick={() => onPageChange(page)}>
              {page}
            </a>
          </li>
        ))}

        {/* Last Page Button with Ellipsis */}
        {endPage < totalPages && (
          <>
            <li key="end-ellipsis">...</li>
            <li>
              <a onClick={() => onPageChange(totalPages)}>{totalPages}</a>
            </li>
          </>
        )}

        {/* Next Button */}
        {currentPage < totalPages && (
          <li>
            <a onClick={() => onPageChange(currentPage + 1)}>
              <img src={arrowRight} alt="Next" />
            </a>
          </li>
        )}
      </ul>
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default Pagination;
